import * as React from 'react';
import {Query} from 'react-apollo';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSyncStatuses as GetSyncStatusesQuery,
    UserEmail as UserEmailFragment,
} from 'nutshell-graphql-types';

import GET_SYNC_STATUSES_QUERY from '../../integrations/graphql/queries/get-sync-statuses.graphql';

class EmailSyncQuery extends Query<GetSyncStatusesQuery, Record<any, any>> {}

type Props = {
    children: (arg1: {
        allUserEmailAddresses?: UserEmailFragment[];
        refetch: () => Promise<any>;
        isLoading: boolean;
        errorMessage: string | null | undefined;
    }) => React.ReactElement;
};

export const GetEmailSyncSettings = (props: Props) => (
    <EmailSyncQuery
        query={GET_SYNC_STATUSES_QUERY}
        notifyOnNetworkStatusChange={true}
        // @ts-expect-error
        fetchPolicy='cache-and-network'
    >
        {({data, loading, refetch, error}) => {
            const loggedInUser = data && data.loggedInUser;
            const allUserEmailAddresses =
                (loggedInUser && loggedInUser.emailAddresses) || undefined;
            // @ts-expect-error
            const errorMessage = safelyGetGraphQLErrorMessage(error);

            return props.children({
                isLoading: loading,
                errorMessage,
                refetch,
                allUserEmailAddresses,
            });
        }}
    </EmailSyncQuery>
);
